// Format a Date as its local calendar-day string (YYYY-MM-DD).
//
// Do NOT use `date.toISOString().split('T')[0]` for this — toISOString()
// converts to UTC first, which shifts the calendar day backward for any
// timezone ahead of UTC (e.g. IST, UTC+5:30). A date picked as "today" at
// local midnight can serialize to yesterday's date, causing attendance
// marked on one day to be queried under a different day.
export const formatLocalDate = (date = new Date()) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};
